module.exports = __webpack_public_path__ + "inputs/img/banner4.b15f0d81.png";